@if (claims()?.isImpersonating === 'true') {
  <div
    class="fixed left-1/2 top-0 z-50 flex w-[600px] -translate-x-1/2 transform items-center justify-between gap-x-2 rounded-md border border-orange-400 bg-orange px-4">
    <div class="flex items-center gap-x-2">
      <i class="fa fa-lg fa-triangle-exclamation text-orange-400"></i>
      <p class="b1-light">
        Impersonating
        <span class="font-semibold">{{ claims()?.customerName || '' }}</span>
      </p>
    </div>
    <div class="flex items-center gap-x-2">
      <p-button
        [loading]="isSubmittingUnImpersonate()"
        severity="contrast"
        class="p-2"
        (click)="handleClickUnImpersonateUser()"
        >End Session</p-button
      >
    </div>
  </div>
}
<nav
  class="border-gray-200 fixed start-0 top-0 z-40 w-full border-b border-surface-400 bg-white">
  <div class="mx-auto flex items-center justify-between px-5 py-2">
    <div class="flex items-center gap-2 space-x-3 rtl:space-x-reverse">
      @if (onClickSidebarMenuIconButton()) {
        <button
          data-collapse-toggle="navbar-sticky"
          type="button"
          (click)="onClickSidebarMenuIconButton()?.()"
          class="text-primary hover:text-primary-400"
          aria-controls="navbar-sticky"
          aria-expanded="false">
          <span class="sr-only">Open main menu</span>
          <i class="fa-solid fa-lg fa-bars"></i>
        </button>
      }
      <a [href]="homeHref()"><t-home-icon /></a>
    </div>
    <ng-content />
    <div class="flex items-center gap-x-3">
      <div>
        @for (crumb of breadcrumbs(); track $index) {
          <a
            class="b2-reg text-primary hover:underline"
            [routerLink]="crumb.routerLink"
            >{{ crumb.label }}</a
          >
          @if ($index !== (breadcrumbs()?.length || 0) - 1) {
            <span class="px-1 text-primary">/</span>
          }
        }
      </div>

      <button (click)="appTiles.toggle($event)" type="button">
        <button type="button" class="text-black hover:shadow-lg">
          <t-app-tile-icon />
        </button>
        <p-overlayPanel
          #appTiles
          styleClass="before:content-none border-surface-300 border-8">
          <div class="grid grid-cols-2">
            @for (app of userApplications(); track $index) {
              <a
                [href]="app.url"
                (click)="appTiles.toggle($event)"
                class="flex flex-col items-center gap-y-1 border-b-secondary-300 pb-2">
                <div
                  [ngClass]="{
                    'text-white': selectedApp()?.name === app.name,
                    'bg-primary': selectedApp()?.name === app.name,
                  }"
                  class="fa-lg flex size-10 items-center justify-center rounded border border-secondary-300 p-2 text-primary">
                  <ng-container
                    class="text-white"
                    *ngComponentOutlet="app?.icon"></ng-container>
                </div>
                <p
                  class="b2-bold rounded bg-secondary-300 p-1 text-primary"
                  [ngClass]="{
                    'text-white': selectedApp()?.name === app.name,
                    '!bg-primary': selectedApp()?.name === app.name,
                  }">
                  {{ app.friendlyName }}
                </p>
                @if (selectedApp()?.name === app.name) {
                  <div class="h-1 w-full rounded bg-secondary-300"></div>
                }
              </a>
            }
          </div>
          <div class="flex justify-end">
            <a
              class="p-button p-button-sm p-button-outlined"
              [href]="portalAppUrl()"
              >Return to Portal
            </a>
          </div>
        </p-overlayPanel>
      </button>

      <button
        type="button"
        (click)="accountInfo.toggle($event)"
        class="flex size-10 items-center justify-center rounded-full border border-white bg-surface-900 shadow-md">
        <span class="text-white">{{ initials() }}</span>
        <p-overlayPanel
          #accountInfo
          styleClass="before:content-none border-surface-300 border-8">
          <button
            type="button"
            (click)="accountInfo.toggle($event)"
            class="absolute right-4 top-4 z-20 col-start-3 justify-end hover:opacity-75">
            <i class="fa-solid fa-lg fa-xmark"></i>
          </button>
          <div class="relative flex max-w-72 flex-col items-center gap-4 p-2">
            <p class="b1-reg col-start-2 w-full overflow-hidden pt-3">
              {{ user()?.email }}
            </p>

            <div
              class="flex size-8 items-center justify-center rounded-full border border-white bg-surface-900 text-white shadow-md">
              {{ initials() }}
            </div>
            <p class="h5-light">Hi, {{ user()?.firstName }}</p>
            <a
              (click)="accountInfo.toggle($event)"
              [href]="portalAppUrl() + '/account-settings'"
              class="p-button !border-0 !bg-secondary-100 !text-primary hover:!bg-secondary-300"
              severity="info"
              >Account Settings
            </a>
            <div class="flex items-center gap-x-2">
              <a
                href="https://www.iubenda.com/privacy-policy/77985552"
                class="hover:underline"
                >Privacy Policy</a
              >
              <span class="">•</span>
              <a
                href="https://svc.transflomobile.com/eula/tfmpeula.html"
                class="hover:underline"
                >Terms of Service</a
              >
            </div>
            <div class="flex items-center justify-center gap-3">
              <a
                tooltipPosition="bottom"
                [autoHide]="false"
                pTooltip="Help / Customer Support"
                href="https://knowledge.transflo.com/trucking-meets-tech/Content/00root/transflo-start.htm">
                <i class="fa-solid fa-sm fa-question"></i>
              </a>
              <button
                pTooltip="Sign out"
                tooltipPosition="bottom"
                [autoHide]="false"
                (click)="handleLogout()"
                class="hover:opacity-75">
                <i class="fa-solid fa-lg fa-right-to-bracket"></i>
              </button>
            </div>
          </div>
        </p-overlayPanel>
      </button>
    </div>
  </div>
</nav>
